import React from 'react'
import styled from 'styled-components'
import { TABLET } from '@streamr/streamr-layout/styled'
import { Xxx as UnstyledXxx } from '../Glyph'
import videos from './videos'
import useTranslation from '~utils/useTranslation'

const Nav = styled.div`
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;
    width: 100%;

    button {
        background: transparent;
        border: 0;
        cursor: pointer;
        outline: 0;
        padding: 1.25rem;
    }

    @media (min-width: ${TABLET}px) {
        button {
            padding: 2.5rem 2.25rem;
        }
    }
`

const Xxx = styled(UnstyledXxx)`
    display: block;
    width: 1rem;

    path {
        stroke: white;
    }

    @media (min-width: ${TABLET}px) {
        width: 1.5rem;
    }
`

const Footer = styled.div`
    flex-shrink: 0;
    height: calc(2 * 1.5rem + 1rem);

    @media (min-width: ${TABLET}px) {
        height: calc(2 * 2.5rem + 1.5rem);
    }
`

const UnstyledVideoPlayer = ({ className, onCloseClick = () => {}, id }) => {
    const { t } = useTranslation()

    return (
        <div className={className}>
            <Nav>
                <div />
                <button type="button" onClick={onCloseClick}>
                    <Xxx thin />
                </button>
            </Nav>
            {!!videos[id] && (
                <iframe
                    title={t('top.hero.videoTitle')}
                    src={videos[id].url}
                />
            )}
            <Footer />
        </div>
    )
}

const VideoPlayer = styled(UnstyledVideoPlayer)`
    align-items: center;
    background-color: black;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    left: 0;
    overflow: auto;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2;

    iframe {
        border: none;
        display: block;
        height: 100%;
        width: 100%;
    }
`

export default VideoPlayer
